import { render, staticRenderFns } from "./table61.vue?vue&type=template&id=1e1aaf04&scoped=true"
import script from "./table61.vue?vue&type=script&lang=js"
export * from "./table61.vue?vue&type=script&lang=js"
import style0 from "./table61.vue?vue&type=style&index=0&id=1e1aaf04&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1aaf04",
  null
  
)

export default component.exports